export default __webpack_public_path__ + "static/media/candidate-management.f44eb4cc.svg";